import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export async function summarizeDecision(title, decisionText) {
  const res = await fetch(`${API_BASE}/api/ai/summarize-decision`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ title, decisionText }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر توليد الملخص'));
  return data.result ?? '';
}

export async function draftDecision(idea) {
  const res = await fetch(`${API_BASE}/api/ai/draft-decision`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ idea }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر صياغة القرار'));
  return data.result ?? '';
}
